// PRC-019 · B2: Overview antes de cargar datos (estado vacío común, PRC-032).
import React from 'react';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import { useLocation, useNavigate } from 'react-router-dom';
import { currentOrigin, withReturnTo } from '../navigation';
import EmptyState from './EmptyState';

const OverviewEmptyState: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <EmptyState
      icon={<InsertChartOutlinedIcon />}
      title="Aún no hay ventas cargadas"
      text="Cuando cargues tu histórico verás aquí margen e ingresos por cliente y producto, y las situaciones que merecen una revisión."
      actionLabel="Cargar histórico de ventas"
      onAction={() => navigate(withReturnTo('/data-upload', currentOrigin(location)))}
      minHeight={240}
    />
  );
};

export default OverviewEmptyState;
